import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import GoogleAutocomplete from "./GoogleAutoComplete";
import SearchFilter from "./SearchFilter";

const HotelAdminFilter = ({ body, setBody, searchHandler, statusFilterOptionArr, type, showRegionFilter = true }) => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState(body.search || "");
  const [debouncedAddress, setDebouncedAddress] = useState(body.address || "");

  // Debounce address changes
  useEffect(() => {
    const handler = setTimeout(() => {
      if (debouncedAddress !== body.address) {
        setBody((prev) => ({
          ...prev,
          address: debouncedAddress,
          lat: prev.lat,
          lng: prev.lng,
          page: 1,
        }));
      }
    }, 500); // 500ms delay

    return () => clearTimeout(handler);
  }, [debouncedAddress]);

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({ ...prev, status: value, page: 1 }));
  };
  const handleFilterChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({
      ...prev,
      filter: value,
      startDate: value === "custom" ? prev.startDate : "",
      endDate: value === "custom" ? prev.endDate : "",
      page: 1,
    }));
  };
  const handleCheckInFilterChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({
      ...prev,
      checkInFilter: value,
      checkInStartDate: value === "custom" ? prev.checkInStartDate : "",
      checkInEndDate: value === "custom" ? prev.checkInEndDate : "",
      page: 1,
    }));
  };
  const handleCheckInDateChange = (key, value) => {
    setBody((prev) => ({
      ...prev,
      [key]: value,
      checkInFilter: "custom",
      page: 1,
    }));
  };

  const handleCountryChange = (e) => {
    const value = e.target.value;
    setBody((prev) => ({ ...prev, country: value, page: 1 }));
  };

  const handleRegionChange = (data) => {
    // Update internal debouncedAddress first
    setDebouncedAddress(data.address || "");

    // Optionally store lat/lng immediately
    setBody((prev) => ({
      ...prev,
      lat: data.lat || "",
      lng: data.lng || "",
      page: 1,
    }));
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    setBody((prev) => ({ ...prev, search: value, page: 1 }));
  };

  const clearFilters = () => {
    setSearchValue("");
    setDebouncedAddress("");
    setBody((prev) => ({
      ...prev,
      status: "",
      address: "",
      country: "",
      search: "",
      filter: "",
      startDate: "",
      endDate: "",
      checkInFilter: "",
      checkInStartDate: "",
      checkInEndDate: "",
      lat: "",
      lng: "",
      page: 1,
    }));
  };

  return (
    <div className="bg-white rounded-3 mb-1" style={{ fontSize: "14px" }}>
      <div className="d-flex flex-wrap gap-3 align-items-end">
        {type === "transaction" ? (
          <div style={{ minWidth: "150px" }}>
            <Form.Label className="fw-semibold text-muted mb-1">
              {t("labels.filterbyStatus")}
            </Form.Label>
            <Form.Select
              value={body.status || ""}
              onChange={handleStatusChange}
              className="shadow-sm mb-1"
            >
              {statusFilterOptionArr?.length ? statusFilterOptionArr?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              )) : ["", "success", "pending", "failed"].map((option) => (

                <option className="text-text-capitalize" key={option} value={option}>{option === "" ? t("common.all") : option}</option>

              ))}
            </Form.Select>
          </div>
        ) :type==="coupon"?(
          <div style={{ minWidth: "150px" }}>
            <Form.Label className="fw-semibold text-muted mb-1">
              {t("labels.filterbyStatus")}
            </Form.Label>
            <Form.Select
              value={body.status || ""}
              onChange={handleStatusChange}
              className="shadow-sm mb-1"
            >
               {["", "Active", "Inactive", "Expired"].map((option) => (

                <option className="text-text-capitalize" key={option} value={option}>{option === "" ? t("common.all") : option}</option>

              ))}
            </Form.Select>
          </div>
        ) :type==="bookings"?<>
        
          <div style={{ minWidth: "150px" }}>
            <Form.Label className="fw-semibold text-muted mb-1">
              {t("labels.filterbyStatus")}
            </Form.Label>
            <Form.Select
              value={body.status || ""}
              onChange={handleStatusChange}
              className="shadow-sm mb-1"
            >
              <option value="">All</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              <option value="Blocked">Blocked</option>
            </Form.Select>
          </div>
           <div style={{ minWidth: "150px" }}>
            <Form.Label className="fw-semibold text-muted mb-1">
              {t("labels.filterbyTime")}
            </Form.Label>
            <Form.Select
              value={body.checkInFilter || ""}
              onChange={handleCheckInFilterChange}
              className="shadow-sm mb-1"
            >
              <option value="">All</option>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="last7days">Last 7 Days</option>
              <option value="last30days">Last 30 Days</option>
              <option value="thisMonth">This Month</option>
              <option value="lastMonth">Last Month</option>
              <option value="custom">Custom</option>
            </Form.Select>
          </div>
          {body.checkInFilter === "custom" && (
            <>
              <div style={{ minWidth: "150px" }}>
                <Form.Label className="fw-semibold text-muted mb-1">
                  Check-in Start
                </Form.Label>
                <Form.Control
                  type="date"
                  value={body.checkInStartDate || ""}
                  onChange={(e) =>
                    handleCheckInDateChange("checkInStartDate", e.target.value)
                  }
                  className="shadow-sm mb-1"
                />
              </div>
              <div style={{ minWidth: "150px" }}>
                <Form.Label className="fw-semibold text-muted mb-1">
                  Check-in End
                </Form.Label>
                <Form.Control
                  type="date"
                  value={body.checkInEndDate || ""}
                  onChange={(e) =>
                    handleCheckInDateChange("checkInEndDate", e.target.value)
                  }
                  className="shadow-sm mb-1"
                />
              </div>
            </>
          )}
        </>:type==="graph"?<>
          <div style={{ minWidth: "150px" }}>
            <Form.Label className="fw-semibold text-muted mb-1">
              {t("labels.filterbyTime")}
            </Form.Label>
            <Form.Select
              value={body.filter || ""}
              onChange={handleFilterChange}
              className="shadow-sm mb-1"
            >
              {/* <option value="">All</option> */}
              <option value="month">Month</option>
              <option value="year">Year</option>
              <option value="today">Today</option>
              <option value="custom">Custom</option>
            </Form.Select>
          </div>
          {body.filter === "custom" && (
            <>
              <div style={{ minWidth: "150px" }}>
                <Form.Label className="fw-semibold text-muted mb-1">
                  Start Date
                </Form.Label>
                <Form.Control
                  type="date"
                  value={body.startDate || ""}
                  onChange={(e) =>
                    setBody((prev) => ({
                      ...prev,
                      filter: "custom",
                      startDate: e.target.value,
                      page: 1,
                    }))
                  }
                  className="shadow-sm mb-1"
                />
              </div>
              <div style={{ minWidth: "150px" }}>
                <Form.Label className="fw-semibold text-muted mb-1">
                  End Date
                </Form.Label>
                <Form.Control
                  type="date"
                  value={body.endDate || ""}
                  onChange={(e) =>
                    setBody((prev) => ({
                      ...prev,
                      filter: "custom",
                      endDate: e.target.value,
                      page: 1,
                    }))
                  }
                  className="shadow-sm mb-1"
                />
              </div>
            </>
          )}
        
        </>: (
          <div style={{ minWidth: "150px" }}>
            <Form.Label className="fw-semibold text-muted mb-1">
              {t("labels.filterbyStatus")}
            </Form.Label>
            <Form.Select
              value={body.status || ""}
              onChange={handleStatusChange}
              className="shadow-sm mb-1"
            >
              <option value="">All</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
              <option value="Blocked">Blocked</option>
            </Form.Select>
          </div>
        )}

        {/* <div style={{ minWidth: "150px" }}>
          <Form.Label className="fw-semibold text-muted mb-1">
            Filter by Country
          </Form.Label>
          <Form.Select
            value={body.country || ""}
            onChange={handleCountryChange}
            className="shadow-sm mb-1"
          >
            <option value="">All</option>
            <option value="Vietnam">Vietnam</option>
            <option value="Thailand">Thailand</option>
          </Form.Select>
        </div> */}

        {/* Region */}
        {/* {showRegionFilter &&
          <div style={{ minWidth: "200px" }}>
            <Form.Label className="fw-semibold text-muted mb-1">
              Filter by Region
            </Form.Label>
            <GoogleAutocomplete
              address={debouncedAddress}
              lat={body.lat || ""}
              lng={body.lng || ""}
              onChange={handleRegionChange}
            />
          </div>} */}

        {/* Search */}
       { searchHandler&&<div style={{ minWidth: "200px" }}>
          <Form.Label className="fw-semibold text-muted mb-1">
            {t("common.search")}
          </Form.Label>
          <SearchFilter
            body={body}
            setBody={setBody}
            searchHandler={searchHandler}
          />
        </div>}

        {/* Clear */}
        <div className="d-flex align-items-end">
          <Button
            variant="secondary"
            size="sm"
            className="fw-semibold"
            style={{ height: 40, minWidth: 50 }}
            onClick={clearFilters}
          >
            {t("common.clear")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HotelAdminFilter;
